import { render } from "./index.vue?vue&type=template&id=075e80b2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=075e80b2&scoped=true&lang=scss"

import exportComponent from "D:\\code\\csgj\\sjg-wine-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075e80b2"]])

export default __exports__